module.exports = __webpack_public_path__ + "media/images/home/screen_11-c2b62c957b39482cb1c14aa3fe3bae52.png";